import React from "react";
import TTSForm from "../../components/common/TTSForm";
import ImgPratikKart from "../../assets/images/pratik-kart.jpeg";
import PageTitle from "../../assets/images/city-image-navigation.jpeg";
import { products } from "../../data/products";
import ImgRoadHd from "../../assets/images/road-hd.jpg"
export default function ShellPratikKart() {
  const pageImage = products.find((p) => p.link === window.location.pathname)?.img;

  return (
    <div className="container-fluid animate pageWrapper">
      {/* <!--Page--> */}
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>Shell Pratik Kart</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="/urunler">Ürünler</a>{" "}
                  {">"} <a href="#">Shell Pratik Kart</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}
        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textRow">
                <h2 className="title">
                  <b>Shell Pratik Kart</b>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row mt-3 start-sm center-xs">
              {/* <!--urun--> */}
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <img
                      src={pageImage ?? ""}
                      height="263"
                      width="375"
                    />
                  </span>
                </div>
              </div>
              {/* <!--/urun--> */}
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div className="textCapsule">
                  <h3>Shell Pratik Kart Nedir?</h3>

                  <p>
                    <b>
                      Shell Pratik Kart iş d&uuml;nyasında g&ouml;n&uuml;lleri
                      fethetmek &uuml;zere sunulan d&ouml;nemsel yakıt alım
                      ihtiyacını karşılayan yakıt kartıdır.
                    </b>
                  </p>

                  <p>
                    SHELL&rsquo;in yeni &ouml;deme metodu Shell Pratik Kart;
                    sadece yakıt alımlarında ge&ccedil;erli olmak &uuml;zere,
                    &ouml;deme evresini pratik hale getiren bakiyeli bir yakıt
                    kartıdır. Kurumsal iş ortaklarınıza,
                    distrib&uuml;t&ouml;rlerinize ve/veya bayilerinize
                    d&ouml;nemsel yakıt alımı ihtiyacınızı karşılamak amacıyla
                    bakiye y&uuml;kl&uuml; olarak verilen şifresiz bir karttır.
                  </p>

                  <p>
                    &nbsp;&bull;&nbsp; Anlaşmalı 1000&rsquo;e yakın Shell
                    istasyonunda ge&ccedil;erli olup, pratik ve hızlı yakıt
                    ikmali sağlar.
                    <br /> &nbsp;&bull;&nbsp; Shell Pratik Kart bakiyesi,
                    g&uuml;ncellendiği tarihten itibaren 3 yıl i&ccedil;in
                    ge&ccedil;erli olup, tekrar kullanıma uygundur.
                    <br /> &nbsp;&bull;&nbsp; Tek fatura ile operasyonel
                    kolaylık sağlar.
                    <br /> &nbsp;&bull;&nbsp; Her bir kart kişiye g&ouml;re
                    &ouml;zelleştirilebilir.
                    <br /> &nbsp;&bull;&nbsp;Web sitesi &uuml;zerinden online
                    bakiye y&uuml;kleme/g&uuml;ncelleme, kart talebi/takibi ve
                    yakıt alımlarına ilişkin raporlamalar yapabilir, detayları
                    g&ouml;rebilirsiniz.
                  </p>

                  <p>
                    Sizde &ccedil;alışanlarınızın, bayilerinizin veya
                    distrib&uuml;t&ouml;rlerinizin g&ouml;n&uuml;llerini
                    fethetmek isterseniz, hemen Başvurun!
                  </p>
                </div>
              </div>
            </div>
            {/* <!--/urunler--> */}
          </div>
        </div>
        {/* <!--/page--> */}
        {/* <!--login--> */}
        <div className="container-fluid section login-section">
          <div className="container-fluid fullRow">
            <div className="row login start-md center-xs reverse">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xm-12 col-xs-12 text">
                <div className="textCapsule">
                  <h3>Pratik Kart Müşteri Girişi</h3>
                  <p>Filonuzun Yolunda Gitmesi İçin Her Zaman Yanınızdayız.</p>
                  <a
                    href="https://sfs.turkiyeshell.com"
                    className="loginBt"
                    target="_blank"
                  >
                    Pratik Kart Müşteri Girişi
                  </a>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 col-sm-12 col-xm-12 col-xs-12 image"
                style={{
                  backgroundImage: `url(${ImgRoadHd})`,
                }}
              ></div>
            </div>
          </div>
        </div>
        {/* <!--/login--> */}
        {/* <!--talep-formu--> */}
        <div className="container-fluid section page-form-section">
          <div className="container-fluid container">
            {/* <!--Text--> */}
           
            {/* <!--/Text--> */}
            <TTSForm />
          </div>
        </div>
        {/* <!--/talep-formu--> */}
      </div>
      {/* <!--//Page--> */}
    </div>
  );
}
